<template>
  <div>
    <Breadcrumbs title="Setting" />
    <div class="container-fluid">
      <div class="card p-4">
        restart socket server? (use when realtime is not working only.)
        <div class="col-4 mt-3">
          <i class="icofont-repeat"></i>
          <b-button @click="RestartRealtimeService"><i class="icofont icofont-redo"></i> Restart</b-button>
        </div>
      </div>
      <div class="card p-4">
        restart email server? (use when send email, recieve is not working only.)
        <div class="col-4 mt-3">
          <i class="icofont-repeat"></i>
          <b-button @click="RestartEmailService"><i class="icofont icofont-redo"></i> Restart</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
  data() {
    return {
      url: "",
    }
  },
  async created() {
  },
  methods: {
    RestartRealtimeService() {
      this.url = process.env.NODE_ENV === 'production' ? 'https://itonecsp-ws.cloudcentric.app/itone/socket/api/restart_x_1123F2341' : 'https://itonecsp-dev.cloudsoft.co.th/ws-api/api/restart_x_1123F2341';
      //this.url = process.env.NODE_ENV === 'production' ? 'https://itonecsp-ws.cloudcentric.app/itone/socket/api/restart_x_1123F2341' : 'http://localhost:4011/api/restart_x_1123F2341';
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You need to restart realtime service?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, restart it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            let self = this;
            fetch(self.url)
              .then(() => {
                this.$swal.fire(
                  'Restarted!',
                  'Realtime service has been restarted.',
                  'success'
                );
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    RestartEmailService() {
      this.url = process.env.NODE_ENV === 'production' ? '/api/mail/restart_hook_service' : '/api/mail/restart_hook_service';
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You need to restart email service?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, restart it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .GetFetch('ccp', this.url)
              .then((res) => {
                if (res.status == 200) {
                  this.$swal.fire(
                        'Restarted!',
                        'Realtime email service has been restarted.',
                        'success'
                      );
                }
              })
              .catch((err) => {
                this.$swal.fire({
                        icon: 'error',
                        title: 'Try Again',
                        text: err,
                      });
              });
          }
        });
    },
  },
};
</script>

<style>
.rounded-1 {
  border-radius: 1rem !important;
}
</style>